import { Row } from "antd";
import { Header } from "../../../Profile/components/Header";
import ROUTES from "../../../../configs/routesConfig";
import { ListContainer } from "./components/ListContainer";
import { ISelectedConversation } from "../../types/SelectedConversation";

type ConversationsContainerProps = {
  conversation: ISelectedConversation | null;
  setConversation: React.Dispatch<
    React.SetStateAction<ISelectedConversation | null>
  >;
};

export const ConversationsContainer = ({
  conversation,
  setConversation,
}: ConversationsContainerProps) => {
  return (
    <Row className="d-block w-100 h-100">
      <Header title="Messages" navigateTo={ROUTES.ACCOUNTS} />
      <ListContainer
        conversation={conversation}
        setConversation={setConversation}
      />
    </Row>
  );
};
